
export default 'ivu-date-picker-cells';


// WEBPACK FOOTER //
// ./src/views/my-components/custom-date-picker/base/prefixCls.js